import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import MFilter from './modules/filter'
import MSort from './modules/sort'
import MUser from './modules/user'
import MDocuments from './modules/documents'

Vue.use(Vuex)

const dataState = createPersistedState({
  paths: ['user', 'sort', 'filter.procedure', 'filter.record', 'filter.task'],
})

const store = new Vuex.Store({
  modules: {
    filter: MFilter,
    sort: MSort,
    user: MUser,
    documents: MDocuments,
  },
  plugins: [dataState],
})

export default store
